import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Hero from "../../assets/images/hero.jpg";
import "./TempLanding.css";

const ModernLanding = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth - 0.5) * 20,
        y: (e.clientY / window.innerHeight - 0.5) * 20,
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  };

  return (
    <div className="modern-hero">
      {/* Animated Background Elements */}
      <div className="background-container">
        {/* Gradient Orbs */}
        <motion.div
          className="gradient-orb orb-1"
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.3, 0.5, 0.3],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        <motion.div
          className="gradient-orb orb-2"
          animate={{
            scale: [1.2, 1, 1.2],
            opacity: [0.4, 0.6, 0.4],
          }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        <motion.div
          className="gradient-orb orb-3"
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.2, 0.4, 0.2],
          }}
          transition={{
            duration: 12,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />

        {/* Grid Pattern */}
        <div className="grid-pattern" />

        {/* Floating Particles */}
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -30, 0],
              opacity: [0, 1, 0],
            }}
            transition={{
              duration: 3 + Math.random() * 2,
              repeat: Infinity,
              delay: Math.random() * 2,
            }}
          />
        ))}
      </div>

      {/* Main Content */}
      <div className="hero-content">
        <motion.div
          className="hero-grid"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {/* Text Content */}
          <motion.div variants={itemVariants} className="text-section">
            {/* Badge */}
            <motion.div
              className="badge"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <span className="badge-dot" />
              <span className="badge-text">AI-Powered Task Management</span>
            </motion.div>

            {/* Main Heading */}
            <motion.h1 className="main-heading" variants={itemVariants}>
              <span className="heading-white">Organize work</span>
              <br />
              <span className="heading-white">and life </span>
              <motion.span
                className="heading-gradient"
                animate={{
                  backgroundPosition: ["0%", "100%", "0%"],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "linear",
                }}
              >
                finally.
              </motion.span>
            </motion.h1>

            {/* Description */}
            <motion.p className="description" variants={itemVariants}>
              Type just anything into the task field and TodoList's one-of-its-kind
              natural language recognition will instantly fill your to-do-list.
            </motion.p>

            {/* Feature Pills */}
            <motion.div className="feature-pills" variants={itemVariants}>
              {["Smart AI", "Natural Language", "Lightning Fast"].map((feature, i) => (
                <motion.span
                  key={i}
                  className="pill"
                  whileHover={{
                    scale: 1.05,
                  }}
                >
                  {feature}
                </motion.span>
              ))}
            </motion.div>

            {/* CTA Buttons */}
            <motion.div className="cta-buttons" variants={itemVariants}>
              <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                <Link to="/register" className="btn-primary">
                  <motion.div className="btn-shine" />
                  <span className="btn-content">
                    Register Now
                    <motion.span
                      className="btn-arrow"
                      animate={{ x: [0, 5, 0] }}
                      transition={{ duration: 1.5, repeat: Infinity }}
                    >
                      →
                    </motion.span>
                  </span>
                </Link>
              </motion.div>

              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Link to="/login" className="btn-secondary">
                  Login
                </Link>
              </motion.div>
            </motion.div>

           {/* Stats */}
<motion.div
  variants={itemVariants}
  style={{
    display: "flex",
    gap: "2rem",
    paddingTop: "2rem",
    borderTop: "1px solid rgba(255, 255, 255, 0.1)",
  }}
>
  {[
    { label: "Active Users", value: "50K+" },
    { label: "Tasks Completed", value: "1M+" },
    { label: "Time Saved", value: "10K hrs" },
  ].map((stat, i) => (
    <div
      key={i}
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1 + i * 0.1 }}
        style={{
          fontSize: "1.875rem",
          fontWeight: "700",
          color: "white",
        }}
      >
        {stat.value}
      </motion.div>
      <div
        style={{
          fontSize: "0.875rem",
          color: "#d1d5db",
          fontWeight: "500",
        }}
      >
        {stat.label}
      </div>
    </div>
  ))}
</motion.div>
</motion.div>

          {/* Image Section with 3D Effect */}
          <motion.div
            className="image-section"
            variants={itemVariants}
            style={{
              transform: `rotateY(${mousePosition.x * 0.5}deg) rotateX(${-mousePosition.y * 0.5}deg)`,
            }}
          >
            {/* Glow Effect */}
            <motion.div
              className="image-glow"
              animate={{
                opacity: [0.5, 0.8, 0.5],
                scale: [1, 1.05, 1],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />

            {/* Main Image Container */}
            <motion.div
              className="image-container"
              whileHover={{ scale: 1.02 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <img src={Hero} alt="hero" className="hero-image" />

              {/* Overlay Elements */}
              <motion.div
                className="overlay-badge overlay-badge-top"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.5 }}
              >
                <motion.div
                  className="live-dot"
                  animate={{ scale: [1, 1.5, 1] }}
                  transition={{ duration: 2, repeat: Infinity }}
                />
                <span className="live-text">Live</span>
              </motion.div>

              <motion.div
                className="overlay-badge overlay-badge-bottom"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 1.8 }}
              >
                <div className="ai-text">✨ AI Processing...</div>
              </motion.div>
            </motion.div>

            {/* Floating Cards */}
            <motion.div
              className="floating-card floating-card-1"
              animate={{
                y: [0, -10, 0],
                rotate: [-5, 5, -5],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <div className="floating-card-content card-gradient-1" />
            </motion.div>

            <motion.div
              className="floating-card floating-card-2"
              animate={{
                y: [0, 10, 0],
                rotate: [5, -5, 5],
              }}
              transition={{
                duration: 5,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <div className="floating-card-content card-gradient-2" />
            </motion.div>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        className="scroll-indicator"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2 }}
      >
        <motion.div
          className="scroll-border"
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <motion.div
            className="scroll-dot"
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
          />
        </motion.div>
      </motion.div>
    </div>
  );
};

export default ModernLanding;